import { Button } from '@arckit/ui'
import SectionTitle from 'components/global/SectionTitle'
import { Section, Row, Col } from 'components/grid'
import { CoreAdoptionContext } from 'context/CoreAdoption'
import React, { useContext } from 'react'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'
import DigitalSolutionsProductBox from 'components/core-adoption/builder/DigitalSolutionsProductBox'
import { supabase } from 'clients/supabase'

export default function DigitalSolutionsAccess({ ...props }) {
	const { account, language, standard, sessionId } = useContext(CoreAdoptionContext)

	async function logSchoolpaceView() {
		try {
			if (sessionId) {
				const { error } = await supabase.from('core_adoption_sessions').update({ schoolpace_login: true }).eq('id', sessionId)
				if (error) throw new Error(error.message)
			}
		} catch (error: any) {
			console.log(error.message)
		}
	}

	return (
		<Section className="scroll-mt-14" id={formatSectionId(props)}>
			<SectionTitle
				title={language === 'english' ? 'Digital Solutions' : 'Soluciones digitales'}
				text={
					language === 'english'
						? [
								<span key="digitalSolutionsAccessSectionTitlePEnglish">
									You can access a demo of SchoolPace<sup>®</sup>, myARC, and ARC Bookshelf by clicking the button below. To access a demo of ARC Adventures, use
									the Apple Store and Google Play links to download to your device.
								</span>
						  ]
						: [
								<span key="digitalSolutionsAccessSectionTitlePSpanish">
									Puede acceder a una demostración de SchoolPace, myARC, y ARC Bookshelf al hacer clic en el botón "Click to try ARC's Digital Solutions" abajo.
								</span>
						  ]
				}
			/>
			<Row className="mt-8">
				<Col>
					<div className="mb-6 flex justify-center">
						<a
							href={`https://arcid.americanreading.com/authorize?response_type=code&district=${standard === 'teks' ? '889' : '888'}&type=user`}
							target="_blank"
							rel="noopener noreferrer"
						>
							<Button onClick={logSchoolpaceView} label="Click to try ARC's Digital Solutions" size="2xl" />
						</a>
					</div>
					<div className="flex flex-col items-center">
						<h3>{language === 'english' ? 'Credentials' : 'Credenciales'}</h3>
						<span className="block text-lg font-semibold">
							{language === 'english' ? 'Username' : 'Nombre de usuario'}: <span className="font-normal">{account?.username}</span>
						</span>
						<span className="block text-lg font-semibold">
							{language === 'english' ? 'Password' : 'Contraseña'}: <span className="font-normal">{account?.password}</span>
						</span>
					</div>
				</Col>
			</Row>
			<Row className="mt-8">
				{!account?.digital_solutions.includes('SchoolPace') && (
					<DigitalSolutionsProductBox
						name="SchoolPace"
						logo="/images/logos/schoolpace.svg"
						text={
							language === 'english'
								? 'SchoolPace is an online performance management system that provides student performance data for all stakeholders. Teachers, school administrators, and district administrators can access dashboards, reports, and graphics that show detailed information about reading progress.'
								: 'SchoolPace es un sistema de gestión de rendimiento en línea que provee datos sobre el desempeño estudiantil para todas las partes interesadas. Los docentes, administradores escolares y del distrito pueden acceder a tableros, informes y gráficas con información detallada sobre el progreso de lectura.'
						}
					/>
				)}
				{!account?.digital_solutions.includes('SchoolPace Connect') && (
					<DigitalSolutionsProductBox
						name="myARC"
						logo="/images/logos/myarc-logo.svg"
						text={
							language === 'english'
								? 'myARC provides educators with digital access to teacher guides and other curricular materials for effective instruction.'
								: 'myARC proporciona a los educadores acceso digital a guías docentes y otros materiales curriculares para una instrucción eficaz.'
						}
					/>
				)}
				{!account?.digital_solutions.includes('ARC Bookshelf') && (
					<DigitalSolutionsProductBox
						name="ARC Bookshelf"
						logo="/images/logos/arc-bookshelf-logo.svg"
						text={
							language === 'english'
								? "With ARC Bookshelf, students, teachers, and parents can read digital books online in any web browser or offline using native mobile apps for iPhone, iPad, iPod Touch, Android tablets, and Android phones. Browse titles by IRLA reading level to find books that fit. Read books at school, at home, and anywhere in between, all included with the school's subscription."
								: 'Con ARC Bookshelf, los estudiantes, docentes y familias pueden leer libros digitales en línea desde cualquier navegador o fuera de línea usando aplicaciones móviles en su forma nativa para iPhone, iPad, iPod Touch, tabletas Android y celulares Android. Busque títulos por nivel de lectura ENIL ajustados a sus necesidades. La suscripción de su escuela permite acceso a los libros en la escuela, desde el hogar y en su tiempo libre.'
						}
					/>
				)}
				{/* {!account?.digital_solutions.includes('ARC Adventures') && (
					<DigitalSolutionsProductBox
						arcAdventures
						name="ARC Adventures"
						logo="/images/logos/arc-adventures-logo.png"
						text={
							language === 'english'
								? "ARC Adventures is an exciting new way for students to practice reading in a variety of 3D minigames. As they learn, students will earn new clothing, hairstyles, and items to decorate their character. This game currently supports the 1G reading level of American Reading Company's Independent Reading Level Assessment (IRLA.)"
								: 'ARC Adventures es una manera divertida para los estudiantes de practicar la lectura en inglés en una variedad de minijuegos 3D. Mientras leen, pueden ganar vestimenta, peinados y artículos nuevos para decorar a su personaje. En la actualidad, este juego apoya el nivel de lectura 1G del IRLA (Independent Reading Level Assessment) de American Reading Company.'
						}
					/>
				)} */}
				{!account?.digital_solutions.includes('ARC Reads') && (
					<DigitalSolutionsProductBox
						name="ARC Reads"
						logo="/images/logos/arc-reads-logo.svg"
						text="ARC Reads, a student portal for the 100 Book Challenge and ARC Core classrooms, offers powerful tools to enhance reading growth, practice, and engagement. With the Digital Logbook, students log their reading practice, receive book recommendations, and track their reading habits. The My IRLA tool identifies where a student might be able to handle text independently through phonics and vocabulary questions."
					/>
				)}
			</Row>
		</Section>
	)
}
